export default __webpack_public_path__ + "static/media/work-wear.c043059e.JPG";